/**
 *  Date    : 2017/9/9
 *  Author  : CastileMan
 *  Declare : 同一个路由下只设置topSize最高的config
 */

import * as jwx from '@/utils/Jweixin';

let config = null;
export const setConfig = (nextConfig, ...rest) => {
  if(!config || nextConfig.topSize >= config.topSize) {
    config = nextConfig;
    jwx.setShareConfig(...rest);
  }
};

export const removeConfig = (id) => {
  if(config && config.id === id) {
    config = null;
  }
};